// ======== DOM References ========
const certificateForm = document.querySelector('.certificate-form form');
const skipButton = certificateForm.querySelector('.hande-skip-certificate');
const finalButton = certificateForm.querySelector('.ceritificate-proceed');
const overlay = document.querySelector('.certificate-wrapper');
const closeButtons = document.querySelectorAll('.close-certificate-popup, .certificate-overlay');
let formId = null;
let productId = null;
let productTitle = null;
let productMeta = {};

// ======== Utility Functions ========

// Helper: dispatch granular certificate field events
function dispatchCertificateFieldEvent(eventName, extraDetail = {}) {
  if (!productId || !productTitle) return;

  const hasPriceMeta = productMeta && productMeta.price;

  const ecommerce = hasPriceMeta
    ? {
        currency:
          productMeta.currency ||
          (window.Shopify && Shopify.currency && Shopify.currency.active) ||
          '',
        value: Number(productMeta.price) || 0,
        items: [
          {
            imageURL: productMeta.imageURL || '',
            item_brand: productMeta.itemBrand || '',
            item_category: productMeta.itemCategory || '',
            item_id: String(productMeta.itemId || productId || ''),
            item_name: productMeta.itemName || productTitle || '',
            item_sku: productMeta.itemSku || '',
            item_variant: String(productMeta.itemVariant || ''),
            price: Number(productMeta.price) || 0,
            quantity: 1,
            variant_name: productMeta.variantName || '',
          },
        ],
      }
    : undefined;

  window.dispatchEvent(
    new CustomEvent(eventName, {
      detail: {
        product_id: productId,
        product_name: productTitle,
        collection: productMeta.collection || '',
        ecomm_pagetype: 'product',
        ecommerce,
        ...extraDetail,
      },
    }),
  );
}

// Show the certificate popup
function openCertificatePopup(targetFormId, productIdValue, productTitleValue) {
  formId = targetFormId;
  productId = productIdValue;
  productTitle = productTitleValue;
  document.body.classList.add('overflow-hidden');
  overlay.style.display = 'flex';

  window.dispatchEvent(
    new CustomEvent('certificateStarted', {
      detail: {
        productId: productIdValue,
        productTitle: productTitleValue,
      },
    }),
  );
}

// Hide the certificate popup and reset form
function closeCertificatePopup() {
  certificateForm.reset();
  finalButton.setAttribute('disabled', 'true');
  overlay.style.display = 'none';
  document.body.classList.remove('overflow-hidden');
}

// Check if all required fields are filled
function checkRequiredFields() {
  const requiredFields = certificateForm.querySelectorAll('[required]');
  const allFilled = Array.from(requiredFields).every((field) => field.value);

  finalButton.disabled = !allFilled;
}

// Toggle visibility of "gift from" field based on selection
function toggleGiftFromField() {
  const isGift = document.querySelector('input[name="properties[_is_gift]"]:checked')?.value;
  const giftFromGroup = document.querySelector('.gift-from');
  const giftFromInput = giftFromGroup.querySelector('input');

  if (isGift === 'Yes') {
    giftFromGroup.classList.remove('hidden');
    giftFromInput.required = true;
  } else {
    giftFromGroup.classList.add('hidden');
    giftFromInput.required = false;
  }
}

// Transfer data from certificate form to hidden fields in target form
function transferFormData() {
  const mainForm = document.getElementById(formId);
  const hiddenInputs = mainForm.querySelectorAll('.certificate-hidden-data');

  hiddenInputs.forEach((input) => {
    if (input.name === 'properties[_accepts_greetings]') {
      input.value = certificateForm.querySelector(`input[name="${input.name}"]`)?.checked || false;
    } else {
      const value = certificateForm.querySelector(`input[name="${input.name}"]`)?.value || '';
      input.value = value;
    }
  });

  // Trigger the original product form submission
  mainForm.querySelector('.product-form__submit, .product-card__atc')?.click();
}

function handleTextInputs(certificateForm) {
  if (!certificateForm) return;

  const nameInput = certificateForm.querySelector('#name-input');
  const nameError = certificateForm.querySelector('#name-error');
  const ownerInput = certificateForm.querySelector('#owner-input');
  const ownerError = certificateForm.querySelector('#owner-error');

  handleInput(nameInput, nameError);
  handleInput(ownerInput, ownerError);
}

function handleInput(input, error) {
  if (!input || !error) return;

  const max_chars = input.maxLength;

  input.addEventListener('input', (e) => {
    if (e.target.value.length === max_chars) {
      error.classList.remove('visibility-hidden');
    } else {
      error.classList.add('visibility-hidden');
    }
  });
}

handleTextInputs(certificateForm);

// ======== Event Listeners ========

// Dynamically handle clicks on certificate trigger buttons
document.body.addEventListener('click', (e) => {
  const button = e.target.closest('.trigger-certificate-modal-button');
  if (!button) return;

  const dataset = button.dataset || {};

  productMeta = {
    collection: dataset.collectionHandle || '',
    currency: dataset.productCurrency || '',
    price: dataset.productPrice || '',
    imageURL: dataset.productImage || '',
    itemBrand: dataset.productVendor || '',
    itemCategory: dataset.productType || '',
    itemId: dataset.productId || '',
    itemName: dataset.productTitle || '',
    itemSku: dataset.productSku || '',
    itemVariant: dataset.productVariantId || '',
    variantName: dataset.productVariantTitle || '',
  };

  openCertificatePopup(button.dataset.targetForm, button.dataset.productId, button.dataset.productTitle);
});

// Handle close popup click
closeButtons?.forEach((button) => {
  button.addEventListener('click', addToCartWithoutCertificate);
});

// Validate form on input (no tracking here, just UX)
certificateForm.addEventListener('input', () => {
  toggleGiftFromField();
  checkRequiredFields();
});

// Handle certificate form submission
certificateForm.addEventListener('submit', (e) => {
  e.preventDefault();

  // Dispatch event when certificate form is submitted with all data
  window.dispatchEvent(
    new CustomEvent('certificateSubmitted', {
      detail: {
        productId: productId,
        productTitle: productTitle,
        formData: new FormData(certificateForm),
      },
    }),
  );

  transferFormData();
  closeCertificatePopup();
});

skipButton?.addEventListener('click', addToCartWithoutCertificate);

// ======== Field-level tracking ========
// Fire tracking for text fields on blur (not on every keystroke)

const bearNameInputField = certificateForm.querySelector('#name-input');
const belongsToInputField = certificateForm.querySelector('#owner-input');
const giftFromInputField = certificateForm.querySelector('.gift-from input');

if (bearNameInputField) {
  bearNameInputField.addEventListener('blur', (event) => {
    const value = event.target.value || '';

    dispatchCertificateFieldEvent('certificateBearNameChanged', {
      bear_name: value,
    });
  });
}

if (belongsToInputField) {
  belongsToInputField.addEventListener('blur', (event) => {
    const value = event.target.value || '';

    dispatchCertificateFieldEvent('certificateBelongsToNameChanged', {
      belongs_to_name: value,
    });
  });
}

if (giftFromInputField) {
  giftFromInputField.addEventListener('blur', (event) => {
    const value = event.target.value || '';

    dispatchCertificateFieldEvent('certificateGiftGiverChanged', {
      gift_giver_name: value,
    });
  });
}

// Gift (is gift true/false)
const giftRadios = certificateForm.querySelectorAll('input[name="properties[_is_gift]"]');

giftRadios.forEach((radio) => {
  radio.addEventListener('change', () => {
    const selected = certificateForm.querySelector('input[name="properties[_is_gift]"]:checked');
    const isGift = selected ? selected.value === 'Yes' : false;

    dispatchCertificateFieldEvent('certificateIsGiftChanged', {
      is_gift: isGift,
    });
  });
});

// Bear and "belonger" birthdays (first and second date inputs in the certificate form)
const dateInputs = certificateForm.querySelectorAll('input[type="date"]');

const bearBirthdayInput = dateInputs[0];
const belongsToBirthdayInput = dateInputs[1];

if (bearBirthdayInput) {
  bearBirthdayInput.addEventListener('blur', (event) => {
    const value = event.target.value || '';

    dispatchCertificateFieldEvent('certificateBearBirthdayChanged', {
      bear_birthday_date: value,
    });
  });
}

if (belongsToBirthdayInput) {
  belongsToBirthdayInput.addEventListener('blur', (event) => {
    const value = event.target.value || '';

    dispatchCertificateFieldEvent('certificateBelongsToBirthdayChanged', {
      belongs_to_birthday_date: value,
    });
  });
}

function addToCartWithoutCertificate() {
  if (!formId) return;

  const mainForm = document.getElementById(formId);

  mainForm?.querySelector('.product-form__submit, .product-card__atc').click();

  closeCertificatePopup();
}
